import React from 'react';

import {VersionsMenuButton} from 'app/components/general/DetailPage/LeftSidebar/VersionsSidebar/MenuButton/BaseVersionsMenuButton';
import {convertParamsForVersionsQuery} from 'app/components/general/DetailPage/LeftSidebar/VersionsSidebar/utils';
import {useProcedureVersions} from 'app/procedures/api';

import type {LeftSidebarMenuButton} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {ProcedureHashidSerializedType} from 'sweet-types';

export const ProcedureVersionsMenuButton = ({
  object,
  forceTooltipShow,
  hideTooltip,
  location,
  params,
  active,
}: LeftSidebarMenuButton<ProcedureHashidSerializedType>) => {
  const {data: versions} = useProcedureVersions(
    convertParamsForVersionsQuery({objectId: object.id}),
    {refetchOnMountOrArgChange: false}
  );

  if (versions == null) {
    return null;
  }

  return (
    <VersionsMenuButton
      object={object}
      forceTooltipShow={forceTooltipShow}
      hideTooltip={hideTooltip}
      versions={versions.results}
      location={location}
      params={params}
      active={active}
    />
  );
};
